function toggleChevron(detailsId) {
  const details = document.getElementById(detailsId);
  const summary = details.querySelector('summary');
  const icon = summary.querySelector('svg');
  if (details.hasAttribute('open')) {
    icon.style.transform = 'rotate(0deg)';
  } else {
    icon.style.transform = 'rotate(180deg)';
  }
}
